import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import numeral from 'numeral'

import PaymentAgreementBlocker from 'Pods/NewModelUploader/Components/BottomBar/Components/PaymentAgreementBlocker'
import Icon from 'Pods/Shared/Icon/Icon'
import ProjectShareModal from 'Pods/Shared/ShareModal'

import paymentAgreementBlockerFromError from 'Utils/paymentAgreementBlockerFromError'

import CancelJobModal from '../Modals/CancelJobModal'
import CounterOfferModal from '../Modals/CounterOfferModal'
import WithdrawApplicationModal from '../Modals/WithdrawApplicationModal'
import FinishJobModal from '../Modals/FinishJobModal'
import DiscardOfferModal from '../Modals/DiscardOfferModal'
import EditProjectModal from '../Modals/EditProjectModal'
import ExtendDeadlineModal from '../Modals/ExtendDeadlineModal'

const actionTitles = {
  refund: 'Request a refund',
  cancel_job: 'Cancel',
  counter_offer: 'Counter offer',
  withdraw_offer: 'Withdraw offer',
  finish: 'Finish the Project',
  accept_offer: 'Accept',
  withdraw_application: 'Withdraw application',
  edit_job: 'Edit Project details',
  checkout: 'Pay & start working',
  review_template: 'Review Project details',
  edit_offer: 'Edit offer',
  accept_and_pay: 'Accept & Pay',
  generate_invoice: 'Generate invoice',
  discard_offer: 'Discard project',
  apply: 'Apply',
  invite_designers: 'Share',
  accept_changes: 'Accept changes',
  repost: 'Repost',
  edit_deadline: 'Edit deadline',
}

class JobActions extends React.Component {
  constructor() {
    super()

    this.state = {
      isOpen: false,
      cancelModalIsOpen: false,
      counterOfferModalIsOpen: false,
      finishJobModalIsOpen: false,
      withdrawApplicationModalIsOpen: false,
      discardOfferModalIsOpen: false,
      projectShareModalIsOpen: false,
      editProjectModalIsOpen: false,
      extendDeadlineModalIsOpen: false,
      paymentAgreementBlocker: null,
    }

    this.acceptChanges = this.acceptChanges.bind(this)
    this.acceptOffer = this.acceptOffer.bind(this)
    this.toggleActions = this.toggleActions.bind(this)
    this.onAcceptOfferSuccess = this.onAcceptOfferSuccess.bind(this)
    this.onAcceptOfferFailure = this.onAcceptOfferFailure.bind(this)
    this.closePaymentAgreementBlocker = this.closePaymentAgreementBlocker.bind(this)
  }

  closePaymentAgreementBlocker() {
    this.setState({ paymentAgreementBlocker: null })
  }

  componentDidMount() {
    // Checking for buttons only to show modal in project view page and prevent it from being shown in list pages
    if (this.props.asButtons && window.location.search.includes('extend_deadline')) {
      this.setState({ extendDeadlineModalIsOpen: true })
    }
  }

  closeModal(e, modalState) {
    if (e) e.preventDefault()
    this.setState({ [modalState]: false })
  }

  onAcceptOfferSuccess(url) {
    App.events.publish('app:notification:flash:success', 'You have accepted the offer')
    url ? window.location.href = url : window.location.reload()
  }

  onAcceptOfferFailure(error) {
    const blocker = paymentAgreementBlockerFromError(error)

    if (blocker) {
      this.setState({ paymentAgreementBlocker: blocker })
      return
    }

    App.events.publish('app:notification:flash:error', error.response.data.errors.join(', '))
  }

  acceptChanges() {
    axios.put(`/api/internal/jobs/${this.props.id}/accept_changes`,
      { data: { attributes: { application_id: this.props.applicationId } } }).then(this.onAcceptOfferSuccess(null)).catch(this.onAcceptOfferFailure)
  }

  acceptOffer() {
    axios.put(`/api/internal/jobs/${this.props.id}/accept_offer`,
      { data: { attributes: { application_id: this.props.applicationId } } })
      .then(() => this.onAcceptOfferSuccess(null))
      .catch(this.onAcceptOfferFailure)
  }

  acceptAndPay() {
    axios.put(`/api/internal/jobs/${this.props.id}/accept_and_pay`,
      { data: { attributes: { application_id: this.props.applicationId } } })
      .then(response => this.onAcceptOfferSuccess(response.data.data.attributes.url))
      .catch(this.onAcceptOfferFailure)
  }

  performAction(e, action) {
    e.preventDefault()
    e.stopPropagation()

    const actionObject = this.actionsMap()[action]

    switch (actionObject.type) {
      case 'modal':
        return this.setState({
          [actionObject.name]: true,
          isOpen: false,
        })
        break
      case 'link':
        return window.location.href = actionObject.name
      case 'function':
        return this.setState({ isOpen: false }, this[actionObject.name](actionObject))
      case 'support':
        return this.setState({ isOpen: false }, zE('webWidget', 'open'))
      case 'refund-support':
        this.loadSupportWidget()
        return this.setState({ isOpen: false })
      default:
        return null
    }
  }

  loadSupportWidget() {
    window.zESettings = {
      webWidget: {
        color:  {
          theme:        '#19bcc9',
          launcherText: '#fff',
        },
        offset: {
          horizontal: '50px',
          vertical:   '36px'
        }
      }
    };

    var script = document.createElement("script");
    const zendeskWebWidgetKey = window.App?.config?.zendeskWebWidgetKey;
    script.src = `https://static.zdassets.com/ekr/snippet.js?key=${zendeskWebWidgetKey}`;
    script.id  = 'ze-snippet';

    if (window.App && window.App.config && window.App.config.userSignedIn) {
      script.onload = script.onreadystatechange = function () {
        script.onreadystatechange = script.onload = null;

        zE('webWidget', 'identify', { name: window.App.config.username, email: window.App.config.userEmail });

        zE('webWidget', 'prefill', {
          name:  { value: window.App.config.username },
          email: { value: window.App.config.userEmail }
        });

        zE('webWidget', 'open');
      };
    }

    document.body.appendChild(script);
  }

  actionsMap() {
    return {
      refund: { type: 'refund-support' },
      cancel_job: { type: 'modal', name: 'cancelModalIsOpen' },
      counter_offer: { type: 'modal', name: 'counterOfferModalIsOpen' },
      finish: { type: 'modal', name: 'finishJobModalIsOpen' },
      accept_offer: { type: 'function', name: 'acceptOffer' },
      accept_changes: { type: 'function', name: 'acceptChanges' },
      withdraw_application: { type: 'modal', name: 'withdrawApplicationModalIsOpen' },
      edit_job: { type: 'modal', name: 'editProjectModalIsOpen' },
      checkout: { type: 'link', name: `/jobs/${this.props.id}/checkout/payment?application_id=${this.props.applicationId}` },
      review_template: { type: 'link', name: `/3d-modeling-jobs/${this.props.slug}/review` },
      generate_invoice: { type: 'link', name: `/api/internal/jobs/${this.props.id}/generate-invoice` },
      edit_offer: {
        type: 'link',
        name: `/3d-modeling-jobs/browse/${this.props.slug}/${this.props.applicationId}/edit`,
      },
      accept_and_pay: { type: 'function', name: 'acceptAndPay' },
      discard_offer: { type: 'modal', name: 'discardOfferModalIsOpen' },
      apply: { type: 'link', name: `/3d-modeling-jobs/browse/${this.props.slug}/apply` },
      invite_designers: { type: 'modal', name: 'projectShareModalIsOpen' },
      repost: { type: 'link', name: `/3d-modeling-jobs/${this.props.slug}/repost` },
      edit_deadline: { type: 'modal', name: 'extendDeadlineModalIsOpen' },
    }
  }

  toggleActions(e) {
    e.preventDefault()
    e.stopPropagation()

    this.setState({ isOpen: !this.state.isOpen })
  }

  renderAsButtons() {
    return (
      <Fragment>
        <span className="publishing-actions__buttons">
          {this.state.paymentAgreementBlocker && (
            <PaymentAgreementBlocker
              paymentAgreementBlocker={this.state.paymentAgreementBlocker}
              onClose={this.closePaymentAgreementBlocker}
            />
          )}
          {this.props.availableActions.primary.map((action) => (
            <button
              key={action}
              className={action.indexOf('accept') > -1 ? 'btn btn-primary u-ml10'
                : (action === 'apply' ? 'btn btn-primary btn-sm show-on-hover u-ml10' : 'btn btn-outline-default btn-white u-ml10')}
              onClick={(e) => this.performAction(e, action)}
            >
              {actionTitles[action]}
            </button>
          ))
          }
        </span>
        {this.props.availableActions.secondary.length > 0 && this.renderAsDots([this.props.availableActions.secondary], 'cog')}
      </Fragment>
    )
  }

  renderAsDots(data, icon) {
    return (
      <div className="actions-dropdown" onClick={this.toggleActions}>
        <button className={`btn ${this.props.isBordered ? 'btn-outline-default' : 'btn-transparent'}`}>
          <Icon type={['far', icon]} className="bullets-icon" notSpaced />
        </button>
        {this.state.isOpen && (
          <div className="dropdown--light dropdown--top-right">
            <div className="dropdown__list">
              {data.map(actions => actions.map((action) => (
                <button key={action} className="btn btn-transparent btn-block" onClick={(e) => this.performAction(e, action)}>
                  {actionTitles[action]}
                </button>
              )))}
            </div>
          </div>
        )}
      </div>
    )
  }

  renderPerspective(actions = []) {
    const isYourOffer = actions.filter(action => action === 'counter_offer')

    if (actions.includes('review_template')) {
      return 'Designer\'s offer: '
    }
    return isYourOffer.length < 1 ? 'My offer: ' : this.props.isViewerDesigner ? 'Client\'s offer: ' : 'Designer\'s offer: '
  }

  render() {
    return (
      <Fragment>
        <div className="job-actions">
          {this.props.showOffer && (
            <span className="job-offer-price">
              {this.props.status === 'approved' ? (
                this.renderPerspective(this.props.availableActions.primary)
              ) : (
                'Price: '
              )}
              <strong>{numeral(this.props.offerValue).format('$0')}</strong>
            </span>
          )}
          {(this.props.asButtons || this.props.availableActions.primary.includes('apply')) ? (
            this.renderAsButtons()
          ) : (
            this.renderAsDots([this.props.availableActions.primary, this.props.availableActions.secondary], 'ellipsis-h')
          )
          }
        </div>

        {this.state.cancelModalIsOpen && (
          <CancelJobModal
            modalIsOpen
            id={this.props.id}
            closeModal={(e) => this.closeModal(e, 'cancelModalIsOpen')}
          />
        )}

        {this.state.counterOfferModalIsOpen && (
          <CounterOfferModal
            modalIsOpen
            id={this.props.id}
            applicationId={this.props.applicationId}
            closeModal={(e) => this.closeModal(e, 'counterOfferModalIsOpen')}
          />
        )}

        {this.state.finishJobModalIsOpen && (
          <FinishJobModal
            modalIsOpen
            id={this.props.id}
            type={this.props.type}
            closeModal={(e) => this.closeModal(e, 'finishJobModalIsOpen')}
          />
        )}

        {this.state.withdrawApplicationModalIsOpen && (
          <WithdrawApplicationModal
            modalIsOpen
            id={this.props.id}
            applicationId={this.props.applicationId}
            closeModal={(e) => this.closeModal(e, 'withdrawApplicationModalIsOpen')}
          />
        )}

        {this.state.discardOfferModalIsOpen && (
          <DiscardOfferModal
            modalIsOpen
            id={this.props.id}
            applicationId={this.props.applicationId}
            closeModal={(e) => this.closeModal(e, 'discardOfferModalIsOpen')}
          />
        )}

        {this.state.projectShareModalIsOpen && (
          <ProjectShareModal
            url={this.props.inviteUrl}
            closeModal={(e) => this.closeModal(e, 'projectShareModalIsOpen')}
            showSocial
          />
        )}

        {this.state.editProjectModalIsOpen && (
          <EditProjectModal
            modalIsOpen
            id={this.props.id}
            slug={this.props.slug}
            closeModal={(e) => this.closeModal(e, 'editProjectModalIsOpen')}
          />
        )}

        {this.state.extendDeadlineModalIsOpen && (
          <ExtendDeadlineModal
            modalIsOpen
            id={this.props.id}
            applicationId={this.props.applicationId}
            closeModal={(e) => this.closeModal(e, 'extendDeadlineModalIsOpen')}
          />
        )}
      </Fragment>
    )
  }
}

JobActions.propTypes = {
  id: PropTypes.string.isRequired,
  slug: PropTypes.string.isRequired,
  availableActions: PropTypes.shape({
    primary: PropTypes.array,
    secondary: PropTypes.array,
  }),
  applicationId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  asButtons: PropTypes.bool,
  isViewerDesigner: PropTypes.bool,
  offerValue: PropTypes.number,
  isBordered: PropTypes.bool,
  showOffer: PropTypes.bool,
  status: PropTypes.string,
  type: PropTypes.string,
  inviteUrl: PropTypes.string,
}

JobActions.defaultProps = {
  availableActions: {
    primary: [],
    secondary: [],
  },
  applicationId: 0,
  asButtons: false,
  isViewerDesigner: false,
  offerValue: 0,
  isBordered: false,
  showOffer: false,
  status: '',
  type: '',
  inviteUrl: '',
}

export default JobActions
